<template>
  <div id="coholder" class="coholder">
    <ValidationObserver ref="observer" @submit.prevent="close()" slim>
    <div class="form" :class="[$mq, {TA:isTestAchat}]">
      <h1>
        {{ $t("Contract.Coholder.title") }}
        <span class="close" @click="close()"
          ></span>
      </h1>
      <ValidationObserver v-slot="{ errors, failed }" slim>
        <div class="multi-field inline left" :class="{'error': failed}">
          <BecomeField
            name="civility"
            type="switch"
            v-model="coholderCivility"
            :possibleValues="civilities"
            silentError
          ></BecomeField>
          <BecomeField
            name="last_name"
            :label="$t('Contract.Coholder.lastname')"
            class="flex"
            type="text"
            rules="min:2|max:64|alpha"
            :value="coholderLastName | capitalize"
            @input="coholderLastName = $event"
            required
            silentError
          ></BecomeField>
          <div class="error-block"  v-if="Object.keys(errors).length">
            {{ errors["last_name"][0] }}
          </div>
        </div>
      </ValidationObserver>

      <BecomeField
        name="first_name"
        :label="$t('Contract.Coholder.firstname')"
        :value="coholderFirstName | capitalize"
        @input="coholderFirstName = $event"
        rules="min:2|max:64|alpha"
        type="text"
        required
      ></BecomeField>
    </div>
    </ValidationObserver>
  </div>
</template>

<script>
import BecomeField from "@/components/Form/BecomeField";
import capitalize from "@/mixins/capitalize";
import inscriptionService from "@/services/inscriptionService";
import { mapGetters, mapState } from 'vuex';

export default {
  mixins: [capitalize],
  computed: {
    ...mapState("subscription", ["civility", "firstName", "lastName"]),
    ...mapGetters("subscription", ["isTestAchat"]),
    coholderCivility: {
      get() {
        return this.$store.state.subscription.coholderCivility;
      },
      set(value) {
        this.$store.commit("subscription/setCoholderCivility", value);
      },
    },
    civilities() {
      return [
        { label: this.$t("Contract.Coholder.civilities.MA"), value: "MA" },
        { label: this.$t("Contract.Coholder.civilities.MO"), value: "MO" },
      ];
    },
    coholderLastName: {
      get() {
        return this.$store.state.subscription.coholderLastName;
      },
      set(value) {
        this.$store.commit("subscription/setCoholderLastName", value);
      },
    },
    coholderFirstName: {
      get() {
        return this.$store.state.subscription.coholderFirstName;
      },
      set(value) {
        this.$store.commit("subscription/setCoholderFirstName", value);
      },
    },
  },
  methods: {
    async updateSubscription() {
      let payloadSub = {};

      if (this.coholderFirstName) {
        let civilities = {
          MOMO: "MS",
          MAMA: "DS",
          MOMA: "MM",
          MAMO: "MM",
        };

        let firstName = `${this.firstName} - ${this.coholderFirstName}`;
        let lastName = `${this.lastName} - ${this.coholderLastName}`;
        let civility = civilities[`${this.civility}${this.coholderCivility}`];

        payloadSub["civility"] = civility;
        payloadSub["first_name"] = firstName;
        payloadSub["last_name"] = lastName;
      }

      try {
        await inscriptionService.updateSubscription(payloadSub);
        return true;
      } catch (error) {
        return error.response.data;
      }
    },
    async close() {
      if(this.coholderFirstName || this.coholderLastName) {
        let valid = await this.$refs.observer.validate();
        if (valid) {
          let serverValidation = await this.updateSubscription();

          if (serverValidation === true) {
            this.$emit('close');
          } else {
            Object.keys(serverValidation).forEach((key) => {
              key = key === 'mobile' ? 'phone' : key;
              let error = {};
              error[key] = this.$te(`Validation.${key}`) ? this.$t(`Validation.${key}`) : this.$t(`Validation.fallback`);
              this.$refs.observer.setErrors(error);
            });
          }
        }
      } else {
        this.$emit('close');
      }
    },
  },
  created() {
    // (this.firstName = null), (this.lastName = null), (this.civility = "MA");
  },
  components: {
    BecomeField,
  },
};
</script>

<style lang="scss" scoped>
.form {
  position: relative;

  .close {
    cursor: pointer;
    position: absolute;
    right: 15px;
    top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    background: url("~@/assets/icons/icon-close.svg") no-repeat center/12px 12px $clearYellow;
    font-size: 0.8rem;
  }
}

.flex {
  flex: 1 !important;
}

.zipcode {
  width: 90px !important;
}

.dual :first-child {
  margin-right: 0 !important;
}

.file-input {
  margin-bottom: 5px !important;
}

.files {
  text-align: left;
  margin-left: 15px;
  margin-bottom: 15px;
  .file {
    font-size: 0.8rem;
    padding: 4px 10px;
    border-radius: 5px;
    background: $yellow;
    margin-right: 5px;
  }
}

.TA {
  .close {
    background: url("~@/assets/icons/icon-close-white.svg") no-repeat center/12px 12px $pink;
    
  }
}
</style>


// WEBPACK FOOTER //
// src/views/components/Coholder.vue